import React, { FunctionComponent } from 'react';
import type { Tv } from '../../../types/tvs';
import { TvList } from '../../organisms/tvList';
import { TvSearchForm } from '../../molecules/tvSearchForm';
import { TvTagSearch } from '../../molecules/tvTagSearch';

type Props = {
  tvs: Tv[];
  tvTags: string[];
  keyword: string;
  page: number;
  isLoading: boolean;
  setKeyword: (kw: string) => void;
  handleSearchSubmit: () => void;
  handleTagClick: (tag: string) => void;
  handlePageChange: (newPage: number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  tvs,
  tvTags,
  keyword,
  page,
  isLoading,
  setKeyword,
  handleSearchSubmit,
  handleTagClick,
  handlePageChange,
}) => {
  return (
    <div className="l-articles js-background-fixed">
      <div className="l-articles-inner u-clear tv">
        <h1 className="articles-title">ファッション・アパレル業界の動画一覧</h1>
        <TvSearchForm
          keyword={keyword}
          onChangeKeyword={setKeyword}
          onSubmit={handleSearchSubmit}
        />
        <TvTagSearch tags={tvTags} onTagClick={handleTagClick} />
        <TvList tvs={tvs} currentPage={page} isLoading={isLoading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
};
